module.exports = __webpack_public_path__ + "p.no2.079c831a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/p.no2.jpg
// module id = 8on6
// module chunks = 0